import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Smooth scroll for anchor links
    this.element.addEventListener('click', this.handleClick.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    const link = event.target.closest('a[href^="#"]')

    if (!link) return

    const targetId = link.getAttribute('href')
    if (targetId === '#') return

    const targetElement = document.querySelector(targetId)

    if (targetElement) {
      event.preventDefault()

      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })

      // Update URL without triggering scroll
      if (history.pushState) {
        history.pushState(null, null, targetId)
      }
    }
  }
}